var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonderlicDevelopLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1199 275",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".wonderlic_develop_logo_svg__st0{display:none}.wonderlic_develop_logo_svg__st1{display:inline}.wonderlic_develop_logo_svg__st11{fill:#2a2f3c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_develop_logo_svg__Layer_2",
    className: "wonderlic_develop_logo_svg__st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "wonderlic_develop_logo_svg__st1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wonderlic_develop_logo_svg__SVGID_1_",
    d: "M-288.5-1935.5H1402V219.3H-288.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wonderlic_develop_logo_svg__SVGID_00000045610679335148523450000010764376503295031979_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wonderlic_develop_logo_svg__SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wonderlic_develop_logo_svg__SVGID_00000045610679335148523450000010764376503295031979_)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 477,
    height: 608,
    xlinkHref: "A5A5108C99E58AB3.png",
    transform: "translate(-288.529 -1935.526) scale(3.544)",
    overflow: "visible"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wonderlic_develop_logo_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000116914817432854783230000017718432686697365157_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.217,
    y1: 22.201,
    x2: 284.349,
    y2: 114.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.7 87.6c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000116914817432854783230000017718432686697365157_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000128458599491920458390000002900950672128538018_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.344,
    y1: 40.998,
    x2: 267.476,
    y2: 133.319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.4 87.6c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000128458599491920458390000002900950672128538018_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000178910775949807935980000007984822787598666685_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.597,
    y1: 78.594,
    x2: 233.729,
    y2: 170.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.9 87.6c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000178910775949807935980000007984822787598666685_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000101814943965882861090000008408939391957105852_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.723,
    y1: 97.391,
    x2: 216.856,
    y2: 189.712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.6 87.6c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000101814943965882861090000008408939391957105852_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000049220031709837529270000009756841314073203590_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.9,
    y1: 61.455,
    x2: 247.538,
    y2: 156.085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.6 177.2c-5.1-3.9-6.1-11.2-2.3-16.4l32.8-44.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-32.8 44.9c-3.7 5.2-10.9 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000049220031709837529270000009756841314073203590_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000023987040826805040880000005294618636279187363_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.329,
    y1: 71.367,
    x2: 239.875,
    y2: 164.991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.4 155.2c-5.1-3.9-6.1-11.2-2.3-16.4l16.7-22.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-16.7 22.9c-3.8 5.2-10.9 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000023987040826805040880000005294618636279187363_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000035492814735674929900000010533789003212584374_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.517,
    y1: 103.932,
    x2: 211.327,
    y2: 196.877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126 142.6c-5.1-3.9-6.1-11.2-2.3-16.4l7.5-10.3c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-7.5 10.3c-3.7 5.2-10.9 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000035492814735674929900000010533789003212584374_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000167378405155458900940000000404507216449891216_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.459,
    y1: 77.622,
    x2: 234.592,
    y2: 169.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181 107.1c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.2 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000167378405155458900940000000404507216449891216_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_develop_logo_svg__SVGID_00000022554385705457232480000001913646459209658292_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.585,
    y1: 109.344,
    x2: 206.267,
    y2: 203.094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e43471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fbc91f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.1 177.2c-5.1-3.9-6.1-11.2-2.3-16.4l18.5-25.4c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-18.5 25.4c-3.8 5.2-11 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_develop_logo_svg__SVGID_00000022554385705457232480000001913646459209658292_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_develop_logo_svg__st11",
    d: "M298.1 114h6.4l12.2 34 13.5-37.3 13.5 37.3 12.2-34h6.4l-18.6 51.4-13.5-37.3-13.5 37.3-18.6-51.4zM390.4 112.6c13.3 0 24 10.8 24 25.5s-10.8 25.5-24 25.5c-13.3 0-24-10.8-24-25.5 0-14.8 10.7-25.5 24-25.5zm0 44.3c10 0 17.4-8.1 17.4-18.9s-7.4-18.9-17.4-18.9c-10 0-17.4 8.1-17.4 18.9s7.4 18.9 17.4 18.9zM424.8 114h6.6v8.1c2.3-5.2 7.4-8.9 14.5-8.9 10.4 0 16.8 7.3 16.8 18.1V162h-6.6v-29.2c0-8-4.5-13.1-11.8-13.1-7.5 0-12.8 5.4-12.8 13.5v28.7h-6.6V114zM495.6 112.6c8.9 0 13.8 4.5 16.1 8.6V95.6h6.6v66.5h-6.6v-7.2c-2.2 4.1-7.2 8.6-16.1 8.6-12.6 0-22.9-10.8-22.9-25.5s10.3-25.4 22.9-25.4zm0 44.3c9.7 0 16.9-8.1 16.9-18.9s-7.2-18.9-16.9-18.9c-9.3 0-16.2 8.1-16.2 18.9s6.9 18.9 16.2 18.9zM528.7 138.2c0-15.6 9.7-25.7 22.6-25.7 12.6 0 20.8 10.7 20.8 23.9 0 0 0 1.6-.1 3.1h-36.7c.4 10.6 6.6 17.4 16.1 17.4 6.5 0 10.1-2.5 13.9-6.7l4.4 4.6c-5.7 6.7-11.8 8.5-18.3 8.5-13.5 0-22.8-9.7-22.8-24.7v-.4zm36.3-4.8c0-7.7-6.1-14.2-13.7-14.2-8.3 0-15.1 6.4-15.5 14.2H565zM582.2 114h6.6v8.1c2.2-5.2 7.1-8.9 13.9-8.9 1 0 2.2.1 2.8.2v7.6c-1.1-.3-2.6-.5-4.5-.5-7 0-12.2 5.4-12.2 13.5v28h-6.6v-48zM616.9 95.6h6.6v53.9c0 5.2 1.4 7.4 5.7 7.4 1.1 0 2.2-.1 3.2-.4v6.6c-1.1.3-2.2.4-3.2.4-4.8 0-12.3-1.1-12.3-13.5V95.6zM639.8 101.2c0-2.8 2.2-4.8 4.5-4.8s4.5 2 4.5 4.8-2.2 4.8-4.5 4.8-4.5-2-4.5-4.8zM641 114h6.6v48.1H641V114zM682.2 112.6c6.8 0 12.7 2.5 17.1 7.3l-4 5c-3.4-3.7-8-5.6-13.1-5.6-10 0-17.4 8.1-17.4 18.9s7.4 18.9 17.4 18.9c5.1 0 9.7-1.9 13.1-5.6l4 5c-4.4 4.8-10.3 7.3-17.1 7.3-13.3 0-24-10.8-24-25.5-.1-15 10.7-25.7 24-25.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_develop_logo_svg__st11",
    d: "M765.4 104.3c5 2.6 8.9 6.3 11.7 11.1 2.7 4.8 4.1 10.4 4.1 16.7 0 6.3-1.4 11.9-4.1 16.6-2.7 4.7-6.6 8.4-11.7 11-5 2.6-10.9 3.9-17.5 3.9h-22.1v-63.2h22.1c6.7 0 12.5 1.3 17.5 3.9zm-2.5 43.1c3.6-3.6 5.4-8.7 5.4-15.3 0-6.6-1.8-11.7-5.4-15.4s-8.7-5.6-15.4-5.6h-9v41.7h9c6.6 0 11.7-1.8 15.4-5.4zM837 142.3h-36.6c.3 3.6 1.6 6.5 3.8 8.5 2.2 2.1 5 3.1 8.2 3.1 4.7 0 8.1-2 10-6.1h13.7c-1.4 4.8-4.2 8.8-8.3 11.9-4.1 3.1-9.1 4.7-15.1 4.7-4.8 0-9.2-1.1-13-3.2-3.8-2.1-6.8-5.2-9-9.1-2.1-3.9-3.2-8.4-3.2-13.6 0-5.2 1.1-9.7 3.2-13.7 2.1-3.9 5.1-6.9 8.9-9 3.8-2.1 8.2-3.2 13.1-3.2 4.8 0 9 1 12.8 3.1 3.8 2.1 6.7 5 8.8 8.7 2.1 3.8 3.1 8.1 3.1 13-.1 1.8-.2 3.5-.4 4.9zm-12.8-8.5c-.1-3.3-1.2-5.9-3.5-7.8-2.3-2-5.1-2.9-8.4-2.9-3.1 0-5.8 1-7.9 2.9-2.1 1.9-3.5 4.5-3.9 7.9h23.7zM867.5 151.9l12.7-38.5h13.5l-18.5 50.1h-15.4l-18.5-50.1h13.6l12.6 38.5zM947 142.3h-36.6c.3 3.6 1.6 6.5 3.8 8.5 2.2 2.1 5 3.1 8.2 3.1 4.7 0 8.1-2 10-6.1h13.7c-1.4 4.8-4.2 8.8-8.3 11.9-4.1 3.1-9.1 4.7-15.1 4.7-4.8 0-9.2-1.1-13-3.2-3.8-2.1-6.8-5.2-9-9.1-2.1-3.9-3.2-8.4-3.2-13.6 0-5.2 1.1-9.7 3.2-13.7 2.1-3.9 5.1-6.9 8.9-9 3.8-2.1 8.2-3.2 13.1-3.2 4.8 0 9 1 12.8 3.1 3.8 2.1 6.7 5 8.8 8.7 2.1 3.8 3.1 8.1 3.1 13-.1 1.8-.2 3.5-.4 4.9zm-12.8-8.5c-.1-3.3-1.2-5.9-3.5-7.8-2.3-2-5.1-2.9-8.4-2.9-3.1 0-5.8 1-7.9 2.9-2.1 1.9-3.5 4.5-3.9 7.9h23.7zM969.2 96.6v67h-12.7v-67h12.7zM991 161.2c-3.9-2.1-6.9-5.2-9.1-9.1-2.2-3.9-3.3-8.4-3.3-13.6 0-5.1 1.1-9.7 3.4-13.6 2.3-3.9 5.4-7 9.3-9.1 3.9-2.1 8.3-3.2 13.1-3.2 4.8 0 9.2 1.1 13.1 3.2 3.9 2.1 7 5.2 9.3 9.1 2.3 3.9 3.4 8.4 3.4 13.6 0 5.1-1.2 9.7-3.5 13.6-2.3 3.9-5.5 7-9.4 9.1-4 2.1-8.4 3.2-13.3 3.2-4.8 0-9.2-1.1-13-3.2zm19.5-9.5c2-1.1 3.6-2.8 4.8-5 1.2-2.2 1.8-4.9 1.8-8.1 0-4.8-1.3-8.4-3.8-11-2.5-2.6-5.6-3.8-9.2-3.8s-6.7 1.3-9.1 3.8c-2.4 2.6-3.7 6.2-3.7 11s1.2 8.4 3.6 11c2.4 2.6 5.4 3.8 9 3.8 2.4 0 4.5-.6 6.6-1.7zM1058.9 114.9c2.9-1.5 6.1-2.3 9.8-2.3 4.3 0 8.2 1.1 11.6 3.2 3.5 2.1 6.2 5.1 8.2 9 2 3.9 3 8.4 3 13.5s-1 9.7-3 13.6c-2 4-4.8 7-8.2 9.2-3.5 2.2-7.3 3.3-11.6 3.3-3.7 0-6.9-.8-9.7-2.3-2.8-1.5-5.1-3.4-6.8-5.7v31h-12.7v-74h12.7v7.2c1.5-2.2 3.8-4.1 6.7-5.7zm17.9 15.6c-1.2-2.2-2.9-3.9-4.9-5-2-1.1-4.2-1.7-6.6-1.7-2.3 0-4.4.6-6.5 1.8-2 1.2-3.7 2.9-4.9 5.1-1.2 2.2-1.9 4.9-1.9 7.9s.6 5.6 1.9 7.9c1.2 2.2 2.9 3.9 4.9 5.1 2 1.2 4.2 1.8 6.5 1.8 2.4 0 4.5-.6 6.6-1.8 2-1.2 3.6-2.9 4.9-5.2 1.2-2.2 1.9-4.9 1.9-8-.1-3.1-.7-5.7-1.9-7.9z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonderlicDevelopLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonderlic_develop_logo.a54cd9b42f94d3f8b239899fb97c1382.svg";